import React, { FC } from 'react';

import { PricingStep } from './steps/pricing';
import { ContactsStep } from './steps/contacts';
import { EquipmentStep } from './steps/equipment';
import { FinanceMenuStep } from './steps/financeMenu';
import { useDealBuilderStepNavigation } from '../hooks';
import { ReviewAndSendStep } from './steps/reviewAndSend';
import { DealBuilderStep, StepComponentProps } from '../types';

export const DealBuilderSteps = ({ navigationNode }: StepComponentProps) => {
  const { viewStep } = useDealBuilderStepNavigation();

  const STEP_COMPONENTS: Record<DealBuilderStep, FC<StepComponentProps>> = {
    [DealBuilderStep.Contacts]: ContactsStep,
    [DealBuilderStep.Equipment]: EquipmentStep,
    [DealBuilderStep.Pricing]: PricingStep,
    [DealBuilderStep.FinanceMenu]: FinanceMenuStep,
    [DealBuilderStep.ReviewSend]: ReviewAndSendStep,
  };

  const StepComponent = STEP_COMPONENTS[viewStep];

  return <StepComponent navigationNode={navigationNode} />;
};
